// Vehicle notes on Convermax result cards (Stan 10-28): with a vehicle selected, each card
// shows the matching mgp.fitment_table note, e.g. mechanical vs electronic parking brake.
(() => {
  const cache = {};
  const table = (handle) => cache[handle] || (cache[handle] = fetch(`/products/${handle}?view=fitnote`)
    .then((r) => (r.ok ? r.text() : 'null')).then((t) => { try { return JSON.parse(t) || []; } catch (e) { return []; } })
    .catch(() => []));
  const norm = (s) => String(s || '').trim().toLowerCase();

  const run = () => {
    const cm = window.Convermax;
    const v = cm && cm.isVehicleSelected && cm.isVehicleSelected() ? cm.getVehicle() : null;
    document.querySelectorAll('.cm_product-item').forEach((item) => {
      const link = item.querySelector('.cm_product-item__title');
      if (!link) return;
      const key = v ? `${v.Year}|${v.Make}|${v.Model}|${v.Submodel}` : '';
      if (item.dataset.mgpNote === key) return;
      item.dataset.mgpNote = key;
      item.querySelectorAll('.mgp-result-note').forEach((n) => n.remove());
      if (!v) return;
      const handle = (link.getAttribute('href') || '').split('/products/')[1]?.split(/[?#]/)[0];
      if (!handle) return;
      table(handle).then((rows) => {
        if (item.dataset.mgpNote !== key) return;
        const row = rows.find((r) => String(r.year) === String(v.Year) && norm(r.model) === norm(v.Model)
          && (!v.Submodel || (r.submodels || []).some((s) => norm(s) === norm(v.Submodel))));
        if (!row || !row.note) return;
        const p = document.createElement('p');
        p.className = 'mgp-result-note';
        p.textContent = row.note;
        link.after(p);
      });
    });
  };

  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(run, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', run);
})();
